module.exports = __webpack_public_path__ + "static/media/website-earlycollegevote.546e0c92.png";